import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';
import { useTranslation } from 'react-i18next';

const gqlGet = gql`
  query getCntContributionSeries($where: String, $offset: Int, $limit: Int, $order: String) {
    getCntContributionSeries(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
        isActive
      }
      recordCount
    }
  }
`;

const gqlGetEn = gql`
  query getCntContributionSeries($where: String, $offset: Int, $limit: Int, $order: String) {
    getCntContributionSeries(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: enName
        isActive
      }
      recordCount
    }
  }
`;

function useGetLazyQuery() {
  return useLazyQuery(gqlGet, { fetchPolicy: 'no-cache' });
  //return [null, { loading: null, data: null }];
}

function useGetLazyQueryEn() {
  return useLazyQuery(gqlGetEn, { fetchPolicy: 'no-cache' });
  //return [null, { loading: null, data: null }];
}

export const FieldSelectContributionSeries = ({
  label = 'Σειρά',
  name = 'seriesId',
  defaultValues = {},
  ...rest
}: FsProps) => {
  const { t, i18n } = useTranslation();
  const gr = i18n.language === 'gr';
  const where = JSON.stringify({ isActive: true });
  return (
    <FieldSelectDB
      {...rest}
      label={t(label)}
      name={name}
      // @ts-ignore
      sbLabel={defaultValues?.contributionseries?.name ?? undefined}
      hook={gr ? useGetLazyQuery : useGetLazyQueryEn}
      where={where}
    />
  );
};

